import Swiper from "swiper";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

/**
 * 施工実績スライダー（Swiper）を初期化する関数
 */
export default function initColumnSwiper() {
	// 念のため、画面内にターゲットの要素が存在するときだけ動かす（エラー落ち防止）
	const swiperTarget = document.querySelector(".swiperjs-column");
	if (!swiperTarget) return;

	const resultsSwiper = new Swiper(".swiperjs-column", {
		modules: [Navigation, Pagination],

		loop: true,
		slidesPerView: 1.2,
		centeredSlides: true,
		spaceBetween: 16,
		breakpoints: {
			768: {
				slidesPerView: 2.5,
				spaceBetween: 24,
			},
			1201: {
				slidesPerView: 3.4,
				spaceBetween: 40,
			},
			// 1921: {
			// 	slidesPerView: 5.5,
			// 	spaceBetween: 40,
			// },
		},

		// ページネーション（ドットナビ）
		// pagination: {
		// 	el: ".column-swiper-pagination",
		// 	clickable: true,
		// },

		// ナビゲーション矢印
		navigation: {
			nextEl: ".column-swiper-button-next",
			prevEl: ".column-swiper-button-prev",
		},
	});

	function updateArrowPosition() {
		const imgWrap = swiperTarget.querySelector(".p-columnSlider__imgWrap");
		const prevArrow = swiperTarget.parentElement.querySelector(".column-swiper-button-prev");
		const nextArrow = swiperTarget.parentElement.querySelector(".column-swiper-button-next");

		if (imgWrap && prevArrow && nextArrow) {
			const imgHeight = imgWrap.clientHeight;
			const arrowTop = imgHeight / 2;

			prevArrow.style.top = arrowTop + "px";
			nextArrow.style.top = arrowTop + "px";
		}
	}

	// 各イベント発生時に位置調整を実行
	window.addEventListener("load", updateArrowPosition);
	window.addEventListener("resize", updateArrowPosition);

	// 初回実行（画像読み込みタイミングを考慮して少し遅らせるか、即時実行）
	updateArrowPosition();

	return resultsSwiper;
}
